<template>
  <PublicPageIntro
    eyebrow="Newsletter"
    title="Neues von Mody"
    description="Aktuelle Projekte, Veranstaltungstipps und Neuigkeiten aus unserer Arbeit direkt ins Postfach."
    compact
  />
  <ClientOnly>
    <div class="iframeContainer">
      <component @load="iframeLoading = false" :hidden="iframeLoading" is="iframe" data-w-type="embedded" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://stu89.mjt.lu/wgt/stu89/xvio/form?c=5c8c0c07" width="100%" style="height: 500px;"></component>
      <div v-if="iframeLoading">
        <div class="flex justify-center items-center mt-10">
          <ProgressSpinner style="width: 70px; height: 70px;" strokeWidth="4" />
        </div>
        <div class="text-lg mt-4 text-center mb-10">
          Wird geladen...
        </div>
      </div>
    </div>

    <component is="script" type="text/javascript" src="https://app.mailjet.com/pas-nc-embedded-v1.js"></component>
  </ClientOnly>

</template>
<style lang="scss">


.iframeContainer{
  margin:auto;
  width: 100%;
  min-height: 320px;
  padding: 2rem 1rem;
  @include desktop() {
    width: 600px;
  }
}
</style>
<script setup lang="ts">
  const iframeLoading = ref(true)

</script>
